import { Toaster as SonnerToaster, toast } from "sonner"

// Themed shadcn-style wrapper around sonner's Toaster.
//
// The v2 stack drives all UI chrome through the theme CSS
// variables in `app/javascript/entrypoints/inertia.css`
// (`--popover`, `--popover-foreground`, `--border`, …).
// sonner reads its colors from its own `--normal-*` CSS
// variables, so we map ours onto those here — the toast
// then matches the surrounding theme (and follows
// light/dark automatically, since the tokens do).
//
// `richColors` keeps success/error toasts visually distinct
// (green / red) while the neutral surface still tracks the
// theme. Mounted ONCE in `DefaultLayout` so a single
// portal serves every page and survives navigations.
type ToasterProps = React.ComponentProps<typeof SonnerToaster>

export function Toaster(props: ToasterProps) {
  return (
    <SonnerToaster
      richColors
      position="top-right"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { toast }
